import _ from "lodash";

//https://stackoverflow.com/questions/6150289/how-to-convert-image-into-base64-string-using-javascript
export const toDataFile = file =>
    new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.onloadend = () => resolve(reader.result);
        reader.onerror = reject;
        reader.readAsDataURL(file);
    });